//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import CreateEditTool from './createEditTool.vue';
import { AI_AGENT_TOOL_TYPE, AI_AGENT_TOOL_CUSTOM_TYPE } from '@/utils/constant';

function filterEmptyPayload(payload = {}) {
  const r = {};
  for (const k of Object.keys(payload)) {
    if (payload[k] !== '') {
      r[k] = payload[k];
    }
  }
  return r;
}

export default {
  components: { CreateEditTool },
  props: {
    isSystem: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      AI_AGENT_TOOL_TYPE,
      AI_AGENT_TOOL_CUSTOM_TYPE,
      // 搜索表单
      searchForm: {
        name: '',
        type: '',
      },
      payload: {
        limit: 10,
        offset: 0,
      },
      page: 1,
      pageSize: 10,
      total: 0,
      // 表格
      loading: false,
      list: [],
      // 弹窗
      visible: false,
      editData: {},
      openType: 'create',
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      const jurisdictionArray = [
        'aiAgentAiAgentTools_agent_create',
        'aiAgentAiAgentTools_agent_edit',
        'aiAgentAiAgentTools_agent_delete',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }
      return jurisdictionObj;
    },
  },
  async created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      this.payload = {
        ...filterEmptyPayload(this.payload),
        limit: this.pageSize,
        offset: (this.page - 1) * this.pageSize,
        is_system: this.isSystem,
      };
      try {
        const { agent_tools: agentTools, total_count: total } = await this.$request({
          url: this.$api.listAgentTools,
          data: this.payload,
        });
        this.list = agentTools;
        this.total = parseInt(total);
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.list = [];
        this.loading = false;
      }
    },
    onAdd() {
      this.editData = {};
      this.openType = 'create';
      this.visible = true;
    },
    onEdit(row) {
      this.editData = row;
      this.openType = 'edit';
      this.visible = true;
    },
    onDetail(row) {
      this.$router.push({
        name: `ai-agent-tool-detail`,
        query: { id: row.id, is_system: this.isSystem },
      });
    },
    async onDelete(row) {
      this.$confirm(`确定移除工具[${row.name}]吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const data = {
          id: row.id,
        };
        console.log(data);
        await this.$request({
          url: this.$api.deleteAgentTools,
          data,
        });
        this.$message({
          message: '删除成功',
          type: 'success',
        });
        this.getList();
      });
    },
    // 翻页器
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getList();
    },
    searchList() {
      this.page = 1;
      this.payload.name = this.searchForm.name || '';
      this.payload.type = this.searchForm.type || '';
      this.getList();
    },
    resetForm() {
      this.searchForm.name = '';
      this.searchForm.type = '';
      delete this.payload.name;
      delete this.payload.type;
      this.getList();
    },
  },
};
